import createLoadablePage from 'utils/createLoadablePage';

export default createLoadablePage(() =>
  import(/* webpackChunkName: "app-membership" */ './Routes')
);
